import {appUrl} from '@hconnect/common/hproduce/config'
import {SETTINGS_HOST} from '@hconnect/common/hproduce/config/settings'
import {Icon, NavigationButton} from '@hm/fundamental'
import {useSuiteHierarchyId} from '@hproduce/suite-core'
import {mdiTune} from '@mdi/js'
import {useTranslation} from 'react-i18next'

export const SettingsAppLink = () => {
  const hierarchyId = useSuiteHierarchyId()
  const {t} = useTranslation()

  return (
    <div className="flex px-6">
      <NavigationButton
        onClick={() => window.location.replace(`${appUrl(SETTINGS_HOST)}/suite/${hierarchyId}`)}
        className="rounded-md flex-1"
        data-cy="settings_app_link"
        data-test-id="settings-app-link"
        disabled={!hierarchyId}
        icon={<Icon path={mdiTune} />}
        style={{height: '48px'}}
      >
        <span>{t('suite.header.plantSettingsLink')}</span>
      </NavigationButton>
    </div>
  )
}
